import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner, Alert } from 'react-bootstrap';
import NonIndexableHelmet from '../../components/NonIndexableHelmet';
import { getTokenMeta } from '../../data/nonIndexableMeta';

const ClientJoinPage = () => {
  const { linkId } = useParams();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, ready, error
  const [galeneUrl, setGaleneUrl] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const username = searchParams.get('username') || 'Client';

    if (linkId && token) {
      const baseGaleneUrl = process.env.REACT_APP_GALENE_URL ||
        `${window.location.origin.replace(/\/$/, '')}/session`;
      const url = `${baseGaleneUrl}/group/${linkId}?token=${token}&username=${encodeURIComponent(username)}`;
      setGaleneUrl(url);
      setStatus('ready');
    } else {
      setStatus('error');
    }
  }, [linkId, searchParams]);

  const handleJoin = () => {
    if (galeneUrl) {
      window.location.href = galeneUrl;
    }
  };

  const helmet = <NonIndexableHelmet {...getTokenMeta('/join')} />;

  if (status === 'loading') {
    return (
      <>
        {helmet}
        <div className="auth-page-gradient auth-page-shell">
          <div className="text-center text-white">
            <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
            <p className="mt-3">Préparation de la session...</p>
          </div>
        </div>
      </>
    );
  }

  if (status === 'error') {
    return (
      <>
        {helmet}
        <div className="auth-page-gradient auth-page-shell">
          <Container>
            <Row className="justify-content-center">
              <Col md={6}>
                <Card className="shadow-lg border-0">
                  <Card.Body className="p-5 text-center">
                    <div style={{ fontSize: '4rem', color: '#dc3545' }}>
                      <i className="bi bi-exclamation-circle-fill"></i>
                    </div>
                    <h3 className="mt-3 fw-bold">Lien invalide</h3>
                    <p className="text-muted">
                      Ce lien de dépannage n'est pas valide ou a expiré.
                      Veuillez contacter votre technicien pour obtenir un nouveau lien.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }

  return (
    <>
      {helmet}
      <div className="auth-page-gradient auth-page-shell">
        <Container>
          <Row className="justify-content-center">
            <Col md={6} lg={5}>
              <Card className="shadow-lg border-0">
                <Card.Body className="p-5 text-center">
                  <div style={{ fontSize: '4rem', color: '#0066FF' }}>
                    <i className="bi bi-camera-video-fill"></i>
                  </div>

                  <h2 className="mt-3 fw-bold">Session de dépannage vidéo</h2>

                  <p className="text-muted mb-4">
                    Vous êtes sur le point de rejoindre une session de dépannage vidéo.
                    Cliquez sur le bouton ci-dessous pour commencer.
                  </p>

                  <Alert variant="info" className="text-start">
                    <strong><i className="bi bi-info-circle me-2"></i>Avant de commencer :</strong>
                    <ul className="mb-0 mt-2 small">
                      <li>Autorisez l'accès à votre caméra et microphone</li>
                      <li>Assurez-vous d'avoir une bonne connexion internet</li>
                      <li>Placez-vous dans un endroit bien éclairé</li>
                    </ul>
                  </Alert>

                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100 py-3"
                    onClick={handleJoin}
                  >
                    <i className="bi bi-camera-video me-2"></i>
                    Rejoindre la session
                  </Button>

                  <p className="mt-4 small text-muted">
                    <i className="bi bi-shield-check me-2"></i>
                    Connexion sécurisée et chiffrée
                  </p>
                </Card.Body>
              </Card>

              <div className="text-center mt-4 text-white">
                <p className="small opacity-75">
                  Propulsé par <strong>Assistance Video</strong>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ClientJoinPage;
